import React, { useEffect } from "react";
import "./DocumentsRequired.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";

import docHero from "../../Asset/Images/doc_required.jpg";

import {
  FaIdCard,
  FaUserShield,
  FaUser,
  FaFileMedical,
  FaFileAlt,
  FaImage
} from "react-icons/fa";

const DocumentsRequired = () => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-in-out"
    });
  }, []);

  // Configuration for the document grid using translation keys
  const docList = [
    { id: 1, icon: <FaIdCard />, title: "docs.id_patient_title", highlight: "docs.patient", desc: "docs.id_patient_desc", delay: 100 },
    { id: 2, icon: <FaUserShield />, title: "docs.id_family_title", highlight: "docs.family_member", desc: "docs.id_family_desc", delay: 200 },
    { id: 3, icon: <FaImage />, title: "docs.photo_patient_title", highlight: "docs.patient", desc: "docs.photo_patient_desc", delay: 300 },
    { id: 4, icon: <FaUser />, title: "docs.photo_guardian_title", highlight: "docs.guardian", desc: "docs.photo_guardian_desc", delay: 400 },
    { id: 5, icon: <FaFileMedical />, title: "docs.medical_report_title", highlight: "docs.patient", desc: "docs.medical_report_desc", delay: 500 },
    { id: 6, icon: <FaFileAlt />, title: "docs.discharge_report_title", highlight: "", desc: "docs.discharge_report_desc", delay: 600 },
  ];

  return (
    <div className="docs_page">
      {/* HERO IMAGE */}
      <section className="docs_hero">
        <img src={docHero} alt={t('docs.hero_alt')} />
      </section>

      {/* DOCUMENTS */}
      <section className="docs_section">
        <h2 data-aos="fade-up">
          {t('docs.main_title')}
        </h2>

        <p className="docs_intro" data-aos="fade-up" data-aos-delay="150">
          {t('docs.intro_text')}
        </p>

        <div className="docs_grid">
          {docList.map((doc) => (
            <div className="doc_card" key={doc.id} data-aos="zoom-in" data-aos-delay={doc.delay}>
              <div className="doc_icon">{doc.icon}</div>
              <h3>{t(doc.title)}</h3>
              <p>
                {doc.highlight && <span className="doc_highlight">{t(doc.highlight)} </span>}
                {t(doc.desc)}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* QUOTE / FOOTER NOTE */}
      <section className="docs_quote" data-aos="fade-up">
        <p>{t('docs.footer_note')}</p>
      </section>
    </div>
  );
};

export default DocumentsRequired;